import { styled } from "@mui/system";


export const SectionContainer = styled("div")({
  marginTop: "40px",
  padding: "50px 40px",
  background: "linear-gradient(145deg, rgba(29, 114, 167, 0.08) 0%, rgba(29, 114, 167, 0.03) 100%)",
  transition: "all .3s ease",
  boxShadow: "0 0 0 1px rgba(29, 114, 167, 0.1),0 2px 5px rgba(0,0,0,.2)",
  backdropFilter: "blur(8px)",
  // background: "linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%)",
  borderRadius: "16px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  color: "#fff",
  textAlign: "left",
  maxWidth: "900px",
  margin: "40px auto 0",

  "@media (max-width: 768px)": {
    padding: "40px 25px",
    margin: "40px 20px 0",
  },
});

export const Description = styled("p")({
  fontSize: "16px",
  lineHeight: "1.6",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#e2e8f0",
  marginBottom: "40px",

  "@media (max-width: 768px)": {
    fontSize: "14px",
    marginBottom: "20px",
  },
});


export const Title = styled("h2")({
  fontSize: "28px",
  fontWeight: "700",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#fff",
  marginBottom: "30px",
  lineHeight: "1.4",
  textAlign: "center",

  "@media (max-width: 768px)": {
    fontSize: "22px",
    marginBottom: "25px",
  },
});

export const BoxContainerTitle = styled("h3")({
  fontSize: "20px",
  fontWeight: "700",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#fff",
  marginBottom: "15px",
  lineHeight: "1.3",

  "@media (max-width: 768px)": {
    fontSize: "18px",
    marginBottom: "12px",
  },
});

export const Subtitle = styled("p")({
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "1.5",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#cbd5e1",
  marginBottom: "50px",

  "@media (max-width: 768px)": {
    fontSize: "16px",
    marginBottom: "35px",
  },
});

export const BoxContainer = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "35px",
  marginBottom: "50px",

  "@media (max-width: 968px)": {
    gridTemplateColumns: "1fr",
    gap: "25px",
    marginBottom: "40px",
  },
});

export const Card = styled("div")({
  padding: "30px 25px",
  // background: "rgba(255, 255, 255, 0.05)",
  borderRadius: "12px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  // transition: "all 0.3s ease",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  background: "linear-gradient(145deg, rgba(29, 114, 167, 0.08) 0%, rgba(29, 114, 167, 0.03) 100%)",
  transition: "all .3s ease",
  boxShadow: "0 0 0 1px rgba(29, 114, 167, 0.1),0 2px 5px rgba(0,0,0,.2)",
  backdropFilter: "blur(8px)",

  "&:hover": {
    borderColor: "rgba(33, 147, 218, 0.3)",
    transform: "translateY(-5px)",
    background: "linear-gradient(145deg, rgba(46, 141, 201, 0.08) 0%, rgba(46, 141, 201, 0.03) 100%)",

  },

  "@media (max-width: 768px)": {
    padding: "25px 20px",
  },
});

export const CardText = styled("p")({
  fontSize: "15px",
  lineHeight: "1.6",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#e2e8f0",
  margin: 0,

  "@media (max-width: 768px)": {
    fontSize: "14px",
  },
});

export const CTASection = styled("div")({
  marginTop: "30px",
});

export const CTAText = styled("p")({
  fontSize: "18px",
  fontWeight: "600",
  lineHeight: "1.5",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#fff",
  marginBottom: "25px",
  textAlign: "center",
  padding: "0 20px",

  "@media (max-width: 768px)": {
    fontSize: "16px",
    marginBottom: "20px",
  },
});


export const EmailFormWrapper = styled("div")({
  display: "flex",
  gap: "15px",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "600px",
  margin: "0 auto",
  backgroundColor: "#fff",
  borderRadius: "15px",
  padding: "5px",
  flexWrap: "wrap",

  "@media (max-width: 600px)": {
    width: "100%",
    display: "flex"
  },
  "@media (max-width: 320px)": {
    width: "100%",
    display: "flex",
    maxWidth: "100%"
  }
});

export const EmailInput = styled("input")({
  flex: 1,
  minWidth: "0",
  padding: "14px 20px",
  border: "none",
  color: "#000",
  fontSize: "20px",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  outline: "none",
  transition: "all 0.3s ease",

  "&::placeholder": {
    color: "#94a3b8",
  },

  "@media (max-width: 600px)": {
    width: "100%",
  },
});

export const JoinButton = styled("button")({
  padding: "14px 32px",
  background: "#70F0A3",
  color: "#000",
  border: "none",
  borderRadius: "50px",
  fontSize: "15px",
  fontWeight: "700",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  cursor: "pointer",
  transition: "all 0.3s ease",
  whiteSpace: "nowrap",

  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 20px rgba(112, 240, 163, 0.4)",
    background: "#5FE092",
  },

  "&:active": {
    transform: "translateY(0)",
  },

  "@media (max-width: 600px)": {
    padding: "4px 14px",
    fontSize: "12px"
  },
});

export const SuccessMessage = styled("div")({
  padding: "15px 20px",
  background: "rgba(112, 240, 163, 0.1)",
  border: "1px solid rgba(112, 240, 163, 0.3)",
  borderRadius: "8px",
  color: "#70F0A3",
  fontSize: "15px",
  fontWeight: "600",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  marginTop: "15px",
});

export const Price = styled("div")({
  fontSize: "48px",
  fontWeight: "800",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#fff",
  lineHeight: "1",

  "& span": {
    fontSize: "20px",
    fontWeight: "500",
    color: "#94a3b8",
  },

  "@media (max-width: 768px)": {
    fontSize: "40px",

    "& span": {
      fontSize: "18px",
    },
  },
});